/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

export enum LoyaltyEnum {
	MCRM = "MCRM",
	IIKO = "IIKO",
	PRIME_HILL = "PRIME_HILL",
	PREMIUM_BONUS = "PREMIUM_BONUS",
	LOONA_AI = "LOONA_AI",
	MINDBOX = "MINDBOX",
	SWIP = "SWIP",
	SAILPLAY = "SAILPLAY",
	REMARKED = "REMARKED",
	LOYALTY_PLANT = "LOYALTY_PLANT",
	TEYCA = "TEYCA",
	FOOD_PICASSO = "FOOD_PICASSO",
	UDS = "UDS",
	LOCARDS = "LOCARDS",
	MAXMA = "MAXMA",
}
